import React, { useRef }  from 'react';
import useClickOutside    from "../../../hooks/useClickOutside";
import CloseIconComponent from "../../reusable/CloseIconComponent";

interface Props {
  presets: string[],
  onClick: (id: string) => void,
  title: string,
  pane: number,
  onClose: () => void,
  style?: {
    [propName: string]: string
  }
}

const PresetsComponent: React.FC<Props> = ({presets, onClick, pane, title, onClose, style = {}}) => {
  const ref = useRef<HTMLDivElement>(null);

  useClickOutside(ref, onClose);

  return (
    <div className="camera-triggers"
         ref={ref}
         style={style}
    >
      <div className="camera-triggers__title">
        {title}
        <CloseIconComponent handler={onClose}/>
      </div>
      <div className="camera-triggers__content scroll">
        {
          presets.length > 0
            ? presets.map((preset, i) => (
              <div key={preset + title + pane}
                   className="camera-triggers__item"
                   onClick={(e) => {
                     e.preventDefault();
                     e.stopPropagation();
                     onClick(i.toString())
                   }}
              >
                {preset}
              </div>
            ))
            : <div className='camera-triggers__no-triggers'>No presets</div>
        }
      </div>
    </div>
  );
};


export default PresetsComponent;